import { render, staticRenderFns } from "./add.vue?vue&type=template&id=40dba76b&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=40dba76b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dba76b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40dba76b')) {
      api.createRecord('40dba76b', component.options)
    } else {
      api.reload('40dba76b', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=40dba76b&scoped=true&", function () {
      api.rerender('40dba76b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/usb-cartridge-check/add.vue"
export default component.exports